module.exports = __webpack_public_path__ + "static/whole-life-insurance-hero.2fbe19ae.webp";